import { render, staticRenderFns } from "./ModalFinishMaterial.vue?vue&type=template&id=1f19d662"
import script from "./ModalFinishMaterial.vue?vue&type=script&lang=js"
export * from "./ModalFinishMaterial.vue?vue&type=script&lang=js"
import style0 from "./ModalFinishMaterial.vue?vue&type=style&index=0&id=1f19d662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports